export default __webpack_public_path__ + "static/media/dibs-logo.c6379126.svg";